export default "__VITE_ASSET__B3y5$8Gv__"